import { useState } from "react";
import { Form, Modal, Spinner } from "react-bootstrap";
import { validateEmail } from "../../../helpers";
import { ForgotPassword } from "../../../services";
import { useAuth, useStore } from "../../../hooks";
import { Toast } from "../../Toast";

type FormFields = {
  email: string;
};

type ValidationErrors = Partial<Record<keyof FormFields, string>>;

type Props = {
  show: boolean;
  handleClose: () => void;
  handleSuccess?: () => void;
  handleSwitch: (newMode: any) => void;
};

const ForgotPasswordModal: React.FC<Props> = ({
  show,
  handleClose,
  handleSwitch,
}) => {
  const { storeId } = useStore();
  const { setCustomer } = useAuth();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [validated, setValidated] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormFields>({
    email: "",
  });
  const [errors, setErrors] = useState<ValidationErrors>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" }); // Clear the error when user types
  };

  const validateForm = (): boolean => {
    const newErrors: ValidationErrors = {};
    setValidated(false);

    if (!formData.email) {
      newErrors.email = "Please enter your email address";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email address";
    }

    setErrors(newErrors);
    setValidated(true);

    // Return true if there are no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!validateForm()) return false;

    try {
      setIsLoading(true);

      const { status, message, data } = await ForgotPassword({
        ...formData,
        store_id: storeId,
      });
      if (status) {
        setCustomer({ ...data, id: 0 });
        handleSwitch("reset-password");
      } else {
        Toast.error(message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }

    // handleSuccess();
  };

  return (
    <>
      <Modal
        className="forgot-password login modal-mobile-bottom"
        show={show}
        onHide={handleClose}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="h4">Forgot Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="login_main"
            method="POST"
            validated={validated}
            onSubmit={handleSubmit}
            noValidate
          >
            <Form.Group className="mb-4">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email address"
                name="email"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                required
              />
              {errors.email && (
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <button type="submit" className="login_btn" disabled={isLoading}>
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "Continue"
              )}
            </button>
            <div className="register_colm modal-bottom-text">
              <span
                className="cursor-pointer"
                onClick={() => handleSwitch("login")}
              >
                Back to Login
              </span>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ForgotPasswordModal;
